<template>
    <v-content>
        <v-snackbar :color="callbackResponse.color" :timeout="callbackResponse.timeout" top
                    v-model="callbackResponse.snackbar">
            {{callbackResponse.message}}
            <v-btn @click="callbackResponse.snackbar = false" dark text>Close</v-btn>
        </v-snackbar>

        <v-breadcrumbs :items="breadcrumbsItems" large></v-breadcrumbs>
        <div class="tbl-btn">
            <v-row>
                <template>
                    <div>
                        <v-radio-group v-model="manualType"
                                       row>

                            <v-radio :label="$t('superAdmin')" value="SuperAdmin"></v-radio>
                            <v-radio :label="$t('company')" value="Company"></v-radio>
                            <v-radio :label="$t('branch')" value="Branch"></v-radio>
                            <v-radio :label="$t('depo')" value="Depo"></v-radio>
                        </v-radio-group>
                    </div>
                </template>
                <v-col cols="4" offset-sm="6">
                    <v-row>
                        <v-file-input label="upload file" show-size v-model="formData.document"></v-file-input>
                        <v-btn @click="uploadData" color="blue" dark>{{$t('upload')}} {{$t('document')}} </v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </div>


        <div id="tblDirectUploadData">


            <br>

            <table border="1">
                <thead>
                    <tr>
                        <th>क्र सं</th>
                        <th>लागि</th>
                        <th>डाउनलोड</th>
                        <th>कार्य</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(table,indexT) in tableData" v-bind:key="indexT">
                        <th>{{++indexT}}</th>
                        <th>{{table.manualUserType}}</th>
                        <td>
                            <template v-if="table.manualType === '.pdf'">
                                <a :href="table.manualFile" target="_blank" rel="noopener noreferrer">Download PDF</a>
                            </template>
                            <template v-else-if="table.manualType === '.mp4'">
                                <button @click="downloadVideo(table.manualFile)">Download Video</button>
                            </template>
                        </td>
                        <td><button @click="deleteManual(table.manualID)"><v-icon style="color:red">delete</v-icon></button></td>

                    </tr>

                </tbody>
            </table>
        </div>
    </v-content>
</template>

<script>
    import axios from "axios";
    export default {
        name: "UserManual",
        data() {
            return {
                ubmitStatus: "",
                yearList: [],
                searchFormData: {
                    year: ""
                },
                manualType: 'SuperAdmin',
                formData: {},
                tableData: [],
                search: false,
                callbackResponse: {
                    snackbar: false,
                    timeout: 6000,
                    message: ""
                },
                responseData: {},
                datainfo: {}


            }
        },
        // mixins: [excelExport],
        computed: {
            breadcrumbsItems() {
                return [
                    {
                        text: this.$t('upload'),
                        disabled: false,
                        to: '/Upload/dashboard',
                        exact: true
                    },
                    {
                        text: this.$t('manualUpload_document'),
                        disabled: true,
                    },
                ]
            }
        },

        validations: {

        },

        mounted() {
            this.searchSubmit()
        },


        methods: {
            searchSubmit() {
               
                    this.search = true
                    axios.get('Upload/GetManualList').then(response => {
                        this.tableData = response.data
                    })
            },
            uploadData() {
                var form = new FormData();
                form.append(
                    "File",this.formData.document
                );
                form.append(
                    "FileType", this.manualType
                );

                axios.post('Upload/ManualUploadDoc', form).then(response => {
                    console.log(response)
                    this.formData.excel = ""
                    this.callbackResponse.color = "success"
                    this.callbackResponse.snackbar = true
                    this.callbackResponse.message = "Data imported Successfullly."
                    this.searchSubmit()
                })
            },
            downloadVideo(videoUrl) {
                console.log('a', videoUrl)
                const link = document.createElement('a');
                link.href = videoUrl;
                console.log('aa', link.href)
                const trimmedUrl = link.href.replace('/Upload/', '/');
                link.href = trimmedUrl;

                link.download = 'video.mp4';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            deleteManual(ID) {
                axios.post('Upload/DeleteUserManual/' + ID).then(response => {
                    this.responseData = response
                    this.callbackResponse.color = "success"
                    this.callbackResponse.snackbar = true
                    this.callbackResponse.message = "Data Deleted Successfullly."
                    this.searchSubmit()
                })

            },
        }
    }
</script>

<style lang="scss" scoped>
    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }

    .tbl-btn {
        padding: 1em;
        text-align: right;
    }

    .btn-download {
        text-align: left;
    }

    .total {
        background-color: #d2d2d2;
    }
</style>